<template>
    <div style="margin-top: 1.375rem;">
        <div class="title">{{$t('meg.Entering')}}</div>
        <p style="font-size: .175rem;color: #818AA0;line-height: .1875rem;">Entering Huizhiyi</p>
        <div class="enterMain">
            <div class="left_main">
                <h1 style="font-size: .425rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;">{{$t('meg.Industrial')}}</h1>
                <p style="text-align: justify; text-indent: 2em; margin-top: .65rem;line-height: .425rem; font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;">{{$t('meg.Internet')}}</p>
                <p style="text-align: justify; text-indent: 2em; margin-top: .65rem;line-height: .425rem; font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;">{{$t('meg.research')}}</p>
            </div>
            <div class="right_main"></div>
        </div>
        <div class="daping"></div>
        <div class="dapBottom">
            <span class="bottomMain">{{$t('meg.Clothing')}}</span>
            <span style="width: 0rem;height: .9125rem;opacity: 1;border: .0125rem solid #DDDDDD;margin-top: .4125rem;"></span>
            <span class="bottomMain">{{$t('meg.Full')}}</span>
        </div>
        <div class="intro">
            <div class="leftIntro">
                <h1 style="font-size: 0.425rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 800;color: #002FA7;">{{$t('meg.Trendy')}}</h1>
                <p style="text-align: justify;text-indent: 2em; margin-top: .75rem; line-height: .425rem;font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;">{{$t('meg.perfectly')}}</p>
                <p style="text-align: justify;text-indent: 2em; margin-top: .4375rem;line-height: .425rem; font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 500;color: #333333;">{{$t('meg.future')}}</p>
            </div>
            <div class="rightIntro">
                <div class="rightLeft"></div>
                <div class="rightBox"></div>
            </div>
        </div>
    </div>
</template>

<script>
</script>

<style scoped>
.title {
    font-size: .3rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    color: #333333;
    /* margin-top: .8625rem; */
}
.enterMain {
    margin: 1.35rem 1.7rem;
    display: flex;
}
.left_main {
    width: 10.1rem;
    text-align: left;
}
.right_main {
    width: 8.925rem;
    height: 4.3375rem;
    background: url("../../assets/newImg/floor.png") no-repeat;
    background-size: 100% 100%;
    margin-left: 1.575rem;
}
.daping {
    margin: .7625rem 1.7rem;
    background: url("../../assets/newImg/daping.png") no-repeat;
    background-size: 100% 100%;
    height: 4.3375rem;
    margin-bottom: 0;
}
.dapBottom {
    height: 1.625rem;
    background: #FFFFFF;
    box-shadow: 0rem .0375rem .075rem .0125rem rgba(0,0,0,0.16);
    opacity: 1;
    margin: 0 1.7rem;
    line-height: 1.625rem;
    display: flex;
    justify-content: space-around;
}
.bottomMain {
    font-size: .2rem;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 800;
    color: #000000;
}
.intro {
    margin: .7625rem 1.7rem;
    display: flex;
    text-align: left;
}
.leftIntro {
    /* width: 7.9625rem; */
    flex: 2;
}
.rightIntro {
    /* margin-left: 2.1375rem; */
    display: flex;
    flex: 1;
    margin-left:1.8125rem;
}
.rightLeft {
    width: 4.1rem;
    height: 8.375rem;
    background: url("../../assets/newImg/intro1.png") no-repeat;
    background-size: 100% 100%;
}
.rightBox {
    width: 4.1rem;
    height: 8.375rem;
    background: url("../../assets/newImg/intro2.png") no-repeat;
    background-size: 100% 100%;
    margin-left: .2875rem;
}
</style>
